import {
  TOKEN_EXPIRED,
  TRIGGER_OPEN_CONTINUE_SESSION_DIALOG
} from '@common/utils'
import {
  MolsonButton,
  MolsonDialog,
  MolsonDialogActions,
  MolsonDialogHeader
} from '@components/reusable'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'react-oidc-context'

export const InactivityDialog = ({
  handleSignIn
}: {
  handleSignIn: () => void
}) => {
  const { t } = useTranslation('', {
    keyPrefix: 'common'
  })
  const { signoutRedirect: signOutAndRedirect } = useAuth()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handleTokenExpirationEventFunction = () => {
      setOpen(true)
    }
    window.addEventListener(TOKEN_EXPIRED, handleTokenExpirationEventFunction)
    window.addEventListener(
      TRIGGER_OPEN_CONTINUE_SESSION_DIALOG,
      handleTokenExpirationEventFunction
    )

    return () => {
      window.removeEventListener(
        TRIGGER_OPEN_CONTINUE_SESSION_DIALOG,
        handleTokenExpirationEventFunction
      )
      window.removeEventListener(
        TOKEN_EXPIRED,
        handleTokenExpirationEventFunction
      )
    }
  }, [])

  return (
    <MolsonDialog fullWidth={true} maxWidth="xs" open={open}>
      <MolsonDialogHeader displayDivider={false} title={t('sessionExpired')} />
      <MolsonDialogActions displayDivider={false}>
        <MolsonButton
          color="secondary"
          onClick={() => signOutAndRedirect()}
          variant="outlined"
        >
          {t('logout')}
        </MolsonButton>
        <MolsonButton
          color="primary"
          onClick={handleSignIn}
          variant="contained"
        >
          {t('continueUsingApp')}
        </MolsonButton>
      </MolsonDialogActions>
    </MolsonDialog>
  )
}
